import React from 'react';
import {dollarNumber, centNumber} from '../../utils/Currency'

export const renderInvoiceExceededMaxPaymentLimit = (tooMuchSelected) => {
    if (!tooMuchSelected) return null;
    return (
        <div className='myob' style={{marginTop: '20px'}}>
            <div className='myob-icon-warning alert alert-notification' style={{marginTop: '20px'}}>
                <img className='invoice-list-warning-icon' src={require('../../assets/icons/warning.svg').default}></img><span
                className='invoice-list-warning-msg'>You cannot pay more than $99,999 at once. Please deselect some invoices</span>
            </div>
        </div>
    )
}

export const renderInvoiceListBodyHeader = (invoiceList, paymentInitializing, payDisabled, tapPayInvoice) => {
    const selectedInvoices = invoiceList.data.filter(invoice => invoice.allowOnlinePayment === true && invoice.selected === true);
    const invoicesTotalLong = selectedInvoices.reduce((accumlator, invoice) => accumlator + invoice.dueAmount, 0);
    const invoicesTotal  = parseFloat(invoicesTotalLong).toFixed(2);
    const selectedInvoiceLength = selectedInvoices.length;
    return (
        <div className='invoice_list_sub_header_details pay-all-row' style={{marginTop: '20px'}}>
            <div style={{float: 'left'}}>
                <h4 style={{paddingTop: '3px'}}>
                    {selectedInvoiceLength != 0 && (<span style={{paddingRight: '10px'}}>
                    <strong>{selectedInvoiceLength}</strong> invoice{selectedInvoiceLength > 1 &&
                        <span>s</span>}<strong> (${dollarNumber(invoicesTotal)}{centNumber(invoicesTotal)})</strong> selected</span>)
                    }
                </h4></div>
            <div className='pay-button-panel'>
                <button className={['btn', 'pay-all', payDisabled ? 'btn-default': null, !payDisabled || paymentInitializing ? 'btn-primary' : null].join(' ')}
                        disabled={payDisabled || paymentInitializing}
                        type='button' id='payAll' onClick={tapPayInvoice}>
                    Pay invoice{selectedInvoiceLength > 1 && <span>s</span>}
                </button>
            </div>
        </div>)
}
